module.exports = __webpack_public_path__ + "img/ia-01-3.fc8cc964.jpg";